// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xI_1_","rightAdornment":"Header_rightAdornment__3uJJf"};